import { createContext } from 'react'

import { PromotionalPopupContextProps } from './PromotionalPopupContext.types'

const defaultPromotionalPopupContext = {
  isOpened: false
}

export const PromotionalPopupContext = createContext<PromotionalPopupContextProps>(defaultPromotionalPopupContext)
